import { TITLE_PREFIX, ORDERS_INDEX_ROUTE } from './consts';

export default () => ({
    label: `${TITLE_PREFIX}s`,
    link: ORDERS_INDEX_ROUTE,
    icon: 'orders',
    permission: 'orders.index',
    order: 30,
});
